import { render, staticRenderFns } from "./TablePage.vue?vue&type=template&id=0e54f727&scoped=true&"
import script from "./TablePage.vue?vue&type=script&lang=js&"
export * from "./TablePage.vue?vue&type=script&lang=js&"
import style0 from "./TablePage.vue?vue&type=style&index=0&id=0e54f727&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e54f727",
  null
  
)

export default component.exports